import { ProductCategory } from 'modules/product/definitions/applications/entities/product-category.entity';
import get from 'lodash/get';
import first from 'lodash/first';
import isEmpty from 'lodash/isEmpty';
import { DocumentReviewReferenceDocument } from './document-review-document.entity';
import { ProductRequirement } from './document-review-product-requirement.entity';

class ProductProfile {
  constructor(data) {
    Object.assign(this, data);
  }
}

export class DocumentReviewProduct {
  constructor(data) {
    this.id = data.id;
    this.productName = data.productName;
    this.itemNo = data.itemNo;
    this.barcode = data.barcode;
    this.productCategories = (data.productCategories || []).map((cat) => new ProductCategory(cat));
    this.productWebsite = data.productWebsite;
    this.longDescription = data.longDescription;
    this.productReviewRemark = data.productReviewRemark;
    this.productProfile = data.productProfile ? new ProductProfile(data.productProfile) : null;
    this.isMasterProduct = data.isMasterProduct;
    this.isSharedReviewDocuments = data.isSharedReviewDocuments;
    this.isSharedReferenceDocuments = data.isSharedReferenceDocuments;
    this.isSharedAdditionalInfo = data.isSharedAdditionalInfo;
    this.isSharedRequirements = data.isSharedRequirements;
    this.customProductCategoryFirstLevel = data.customProductCategoryFirstLevel;
    this.customProductCategorySecondLevel = data.customProductCategorySecondLevel;
    this.customProductCategoryThirdLevel = data.customProductCategoryThirdLevel;
    this.poItems = data.poItems || [];
    this.qualityRequirements = data.qualityRequirements || [];
    this.productProfileReferenceDocuments = data.productProfileReferenceDocuments
      ? new DocumentReviewReferenceDocument(data.productProfileReferenceDocuments)
      : null;
    this.productProfileReviewDocuments = data.productProfileReviewDocuments || [];
    this.exportMarket = data.exportMarket;
    this.countryOfOrigin = data.countryOfOrigin;
    this.testAgeGrade = data.testAgeGrade;
    this.labelTestAgeGrade = data.labelTestAgeGrade;
    this.tags = data.tags || [];
    this.qualityRequirements = (data.qualityRequirements || []).map(
      (req) => new ProductRequirement(req)
    );
  }

  static initializeDocumentReviewProduct(productEntity) {
    if (!productEntity) return null;

    const imageFiles = get(productEntity, 'files.default.fileArr', null);
    const companyLogoUrl = isEmpty(imageFiles) ? null : get(first(imageFiles), 'url');
    const suppliers = get(productEntity, 'suppliers.data', []);
    const supplier = first(suppliers);

    const product = new DocumentReviewProduct(productEntity);
    return {
      product: {
        ...product,
        companyLogoUrl,
        productProfileReferenceDocuments: {
          documents: [],
          photos: imageFiles || [],
        },
        productProfile: {
          id: productEntity.id,
          itemNo: productEntity.itemNo,
          name: productEntity.name,
          productFiles: [],
        },
      },
      supplier: get(supplier, 'supplier', null),
    };
  }
}
